<template>
  <div>
    <usernav></usernav>
    <el-col class="LeftPart">
      <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
        <div class="G-title">
          升级VIP
        </div>
        <div class="p3">
          <div class="text-dark">
            第一步，查看会员类型和价格
          </div>
          <el-table
            :data="tableData"
            border
            style="margin: auto">
            <el-table-column
              prop="title"
              label="类型"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="价格"
            >
            </el-table-column>
            <el-table-column
              prop="info"
              label="查看内容">
            </el-table-column>
            <el-table-column
              prop="days"
              label="有效期">
            </el-table-column>
          </el-table>
        </div>
        <div class="p4">
          * 升级成VIP会员后在有效期内无需积分浏览全站内容。
        </div>
        <el-tabs type="card" style="margin: 5px">
          <el-tab-pane v-if="third" v-for="pay of payData" :key="pay.id"  :label=pay.title >
            <div class="text-dark">
              第二步，请先在第三方平台购买完成升级
            </div>
            <div class="p2">
              请在三分钟内完成付款，付款成功后系统自动为您升级会员。
            </div>
            <div class="m2">
              <span style="font-size: 14px"><el-button plain v-for="item of pay['commodity']" @click="create(item.title,item.price,item.id, pay.id)" :key="item.id" style="margin: 5px">
                {{item.title}}{{item.price}}元
              </el-button></span>
            </div>
            <div class="p4">
              * 提示：一次不成功可以尝试重新提交一次。
            </div>
            <div class="p4">
              * 客服邮箱：{{email}}，如果你在购买和使用中出现任何问题，请发邮件给我们并耐心等待回复，我们将会尽快给你解决。
            </div>
            <div class="text-dark">
              第三步，等待系统确认到账
            </div>
            <div style="font-size: 14px">系统确认完成，将会为你自动更新会员等级，请在「会员中心」查看您的会员等级。</div>
          </el-tab-pane>
          <el-tab-pane v-if="ka" label="发卡">
            <div class="text-dark">
              第二步，请先在第三方平台购买对应的会员升级码
            </div>
            <div class="p2">
              付款成功后记得返回本页面，输入升级码完成升级。
            </div>
            <div class="m2">
              <el-button plain v-for="item of tableData" @click="open_link(item.link)" :key="item.id" style="margin: 5px">
                {{item.title}}{{item.price}}元
              </el-button>
            </div>
            <div class="p4">
              * 客服邮箱：{{email}}，如果你在购买和使用中出现任何问题，请发邮件给我们并耐心等待回复，我们将会尽快给你解决。
            </div>
            <div class="text-dark">
              第三步，返回平台，输入你购买的升级码完成升级
            </div>
            <div class="p2">输入升级码，将会自动为你更新会员等级，请在「会员中心」查看。</div>
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-form-inline">
              <el-form-item prop="key" style="padding-top: 10px">
                <el-input type="text" v-model="ruleForm.key" autocomplete="off" onkeyup="this.value=this.value.replace(/[^A-Za-z0-9]+/,'');"></el-input>
              </el-form-item>
              <el-form-item class="form-group" style="text-align: center">
                <el-button :loading="loading" type="primary" @click="submitForm('ruleForm')">立即升级</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane v-if="token" label="USDT支付（95折）">
            <paytoken :tableData="tableData"></paytoken>
          </el-tab-pane>
        </el-tabs>
        <div class="p4">* 请勿为了发布信息去升级VIP，我们审核信息不会因为VIP会员而区别对待，只和信息本身的质量有关系。</div>
        <div class="p4">* 请勿为了信息采集和共享账号去升级VIP，如果你的账号使用频率异常将会被系统自动封号。</div>
      </el-card>
      <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
        <div class="G-title">
          升级帮助
        </div>
        <div class="p3">
          <div class="text-dark">
            充值中碰到问题，升级失败了怎么办？
          </div>
          <div class="p2">
            请提供你的相关账号以及支付信息，然后发邮件给：{{email}}，我们会尽快给你处理。
          </div>
        </div>
        <div class="p3">
          <div class="text-dark">
            有事怎么联系客服?
          </div>
          <div class="p2">
            请提供你的账号以及详细描述你的问题，然后发邮件给：{{email}}，我们会尽快给你处理。
          </div>
        </div>
      </el-card>
      <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
        <div class="G-title">
          使用帮助
        </div>
        <div class="p3">
          <div class="text-dark">
            网站的信息都是真的吗?
          </div>
          <div class="p2">
            本站信息都是全国各地狼友亲自经历后发布的，再由我们网站严格审核后才通过，所以可信度请放心。我们每条信息都有一半已显示出来，特别商家频道，肯定有很多你熟悉的地方，每天那么多的信息更新，我们没有你们想象的那么强大，可以捏造出这么多虚假信息，同时如果你有顾虑，可以尝试给我们贡献内容，获取积分后，你就可以使用积分购买单个信息的联系方式，所以，本站信息是不是真的请你判断，如果你还是认为本站信息是假的，那么请你离开本站。
          </div>
        </div>
        <div class="p3">
          <div class="text-dark">
            为什么网站有一些信息过时了?
          </div>
          <div class="p2">
            由于行业的特殊性，如果这条信息发布时间半年多了，过时了也正常，但请放心，本站每日大量更新全国信息，我们也建议你更多关注最新的信息。
          </div>
        </div>
        <div class="p3">
          <div class="text-dark">
            为什么有些信息的联系方式无效？
          </div>
          <div class="p2">
            由于行业的特殊性，楼凤小姐或者商家联系方式更换比较频繁，同时如果这条信息被很多狼友浏览和添加，也会导致微信或者QQ联系方式被暂时屏蔽或者直接被封。如果你无法搜索QQ和微信，这个时候请你尝试一下手机联系方式，如果长期没回复或者联系方式失效且无法添加，请关注我们同城的其它最新信息即可，我们每日更新大量全国信息，通过我们的最新信息，总会帮你找到快乐和性福。
          </div>
        </div>
        <div class="p3">
          <div class="text-dark">
            为什么有些信息的联系方式无效？
          </div>
          <div class="p2">
            由于行业的特殊性，楼凤小姐或者商家联系方式更换比较频繁，同时如果这条信息被很多狼友浏览和添加，也会导致微信或者QQ联系方式被暂时屏蔽或者直接被封。如果你无法搜索QQ和微信，这个时候请你尝试一下手机联系方式，如果长期没回复或者联系方式失效且无法添加，请关注我们同城的其它最新信息即可，我们每日更新大量全国信息，通过我们的最新信息，总会帮你找到快乐和性福。
          </div>
        </div>
        <div class="p3">
          <div class="text-dark">
            怎么辨别和鉴定虚假联系方式？骗子有一些显著特征呢?
          </div>
          <div class="p2">
            当你对联系对方有所顾虑的时候，请您尝试百度一下这个联系方式，进行多方的比对。
          </div>
          <div class="p4">
            * 凡是要求付定金/保证金等任何提前付费的行为，基本都是骗子。
          </div>
          <div class="p4">
            * 凡是裸聊或者发视频验证，都是来骗钱的，请勿上当。
          </div>
          <div class="p4">
            * 凡是是求见面地方在她附近的，基本是黑凤集团。
          </div>
          <div class="p4">
            * 凡是要求见面地方在交通方便的车站附近的，基本不靠谱。
          </div>
        </div>
      </el-card>
    </el-col>
    <el-col class="RightPart">
      <el-card shadow="never" style="text-align: left">
        <div class="text-dark">
          你也可以使用积分兑换会员
        </div>
        <div class="m2">你的可用积分：{{points}}</div>
        <div class="m2">积分转换会员</div>
        <div v-for="item of tableData" :key="item.points" class="m2">
          <el-popconfirm title="确定要用积分升级VIP吗？"  @confirm="buy_points(item.id)">
            <el-button style="width: 200px" slot="reference" plain size="small"><span style="font-size: 14px">使用{{item.points}}积分兑换{{item.title}}</span></el-button>
          </el-popconfirm>
        </div>
      </el-card>
    </el-col>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      :show-close = false
      :close-on-press-escape =false
      :close-on-click-modal = false
      :lock-scroll = false
      center>
      <span>请在三分钟之内完成付款，请不要更改备注！</span>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="centerDialogVisible = false, open_url()">立即支付</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import Usernav from '@/components/base/header/usernav'
import paytoken from '@/components/user/paytoken'
import {request} from '../../network/request'
export default {
  name: 'upgrade',
  components: {Usernav, paytoken},
  created () {
    this.getCate()
  },
  data () {
    var validateKey = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入卡密'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      payData: [],
      tableData: [],
      points: '-',
      email: '',
      third: false,
      token: false,
      ka: false,
      url: '',
      centerDialogVisible: false,
      ruleForm: {
        key: ''
      },
      rules: {
        key: [
          {validator: validateKey, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    open_url () {
      window.open(this.url)
    },
    create (title, price, id, payid) {
      this.$confirm('您正在使用支付宝支付<br>「' + title + ':' + price + '元」', '检查账单', {
        confirmButtonText: '支付',
        cancelButtonText: '取消',
        lockScroll: false,
        closeOnPressEscape: false,
        dangerouslyUseHTMLString: true,
        showClose: false,
        closeOnClickModal: false
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在拉取支付页面，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let data = new URLSearchParams()
        data.append('cid', id)
        data.append('payid', payid)
        request({
          url: '/api/pay',
          method: 'post',
          data: data
        }).then(res => {
          this.url = res['data']['url']
          this.centerDialogVisible = true
          loading.close()
        }).catch(err => {
          loading.close()
          this.$message.error('拉取失败')
          console.log(err)
        })
      }).catch(() => {
      })
    },
    open_link (url) {
      window.open(url, '_blank')
    },
    buy_points (id) {
      let data = new URLSearchParams()
      data.append('type', '0')
      data.append('id', id)
      request({
        url: '/api/upgrade',
        method: 'post',
        data: data
      }).then(function (res) {
        if (res.data.status === 0) {
          this.$message.success('兑换成功')
          setTimeout(() => {
            this.$router.push('/usercenter')
          }, 100)
        } else {
          this.$message.error('积分不足')
        }
      }.bind(this)).catch(err => {
        console.log(err)
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          let data = new URLSearchParams()
          data.append('type', '1')
          data.append('key', this.ruleForm.key)
          request({
            url: '/api/upgrade',
            method: 'post',
            data: data
          }).then(function (res) {
            if (res.data.status === 0) {
              this.$alert('充值成功，您已成为本站VIP。', '温馨提示', {
                confirmButtonText: '确定',
                lockScroll: true
              })
              setTimeout(() => {
                this.$router.push('/usercenter')
              }, 500)
            } else if (res.data.status === 2) {
              this.$message.warning('卡密已使用,请勿重复充值！')
              setTimeout(() => {
                this.$router.push('/usercenter')
              }, 500)
            } else {
              this.$message.error('卡密错误')
              this.loading = false
            }
          }.bind(this)).catch(err => {
            this.$message.error('网络异常，请重试！')
            console.log(err)
          })
        }
      })
    },
    getCate () {
      request({
        url: '/api/upgrade',
        method: 'get'
      }).then(res => {
        this.points = res.data.points
        this.tableData = res.data.commodity
        this.email = res.data.email
        this.token = res.data.token
        this.third = res.data.third
        this.ka = res.data.ka
        this.payData = res.data.payData
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
  .G-title {
    font-weight: bold;
    border-bottom: 1px solid #f2f2f2 !important;
    padding-bottom: 10px;
  }

  .p4 {
    font-size: 14px;
    color: #f39;
    padding-top: 5px;
    font-weight: bold;
  }

  .p3 {
    padding-top: .5rem !important;
  }

  .p2 {
    font-size: 14px;
  }

  .text-dark {
    font-weight: 600 !important;
    margin-top: .5rem !important;
    margin-bottom: .5rem !important;
    font-size: 14px;
  }

  .m2 {
    margin-bottom: .5rem;
    margin-top: .5rem;
    font-size: 14px
  }

</style>



// WEBPACK FOOTER //
// src/components/user/upgrade.vue